





















import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class IconBarGraph extends Vue {
  @Prop({
    type: String,
    default: "#616161"
  })
  iconColor!: string;
}
